import { Grid } from '@material-ui/core';
import { useQuoteField } from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import { FormRowGrid, GridRowProps } from 'Quoting/components/shared/GridRow';
import { QuoteFormElement } from 'Quoting/components/shared/QuoteFormElement';
import { FormWrapper } from 'Quoting/components/shared/QuoteFormWrapper';
import React from 'react';
import { useSelector } from 'react-redux';
import { ReducerState } from 'rootReducer';
import { GPLU_WHOLE_LIFE_FIELD_ID, GPLUCoverageCode } from '../../../PlanTemplates/GWL/gpluConstants';
import { getGPLUFundingStructurePropertyPaths } from '../PropertyPaths';

export const GPLUFundingStructureBlock = () => {
  const {getQuoteFieldValue, updateQuoteFieldValue} = useQuoteField();
  const {selectedPlan, selectedCoverageIndex} = useSelector((state: ReducerState) => state.quoteForm);

  const propertyPaths = getGPLUFundingStructurePropertyPaths(selectedPlan?.planIndex, selectedCoverageIndex);

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'row-e27aeccd-9daf-40e7-a47d-2bae8c862892'},
      items: [
        {
          key: '4d5fe8b2-6694-4336-9870-ad2034fca6c0',
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              label="Contribution Type"
              id={propertyPaths.contributionTypeCd}
              value={getQuoteFieldValue(propertyPaths.contributionTypeCd)}
              onChange={e => updateQuoteFieldValue(propertyPaths.contributionTypeCd, e.target.value)}
              dropdownVariant="AttributeValue"
              searchKey="GPLUBenefitCoverageFundingStructure.contributionTypeCd"
              coverageCode={GPLUCoverageCode.WHOLE_LIFE}
              disabled
              required
            />
          ),
        },
        {
          key: '28c3605c-ff45-45c1-8572-b18826a00d29',
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Minimum Number of Participants"
              id={propertyPaths.minParticipantsNum}
              value={getQuoteFieldValue(propertyPaths.minParticipantsNum)}
              onChange={e => updateQuoteFieldValue(propertyPaths.minParticipantsNum, e.target.value)}
              type="number"
              disabled
              required
            />
          ),
        },
      ],
    },
    {
      rowProps: {key: 'row-b86ba072-7f56-436a-adc8-51b38ea4ff37'},
      items: [
        {
          key: '8cd8b45d-d00d-4b11-940e-c9e34b1d40aa',
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              label="Payroll Frequency"
              id={propertyPaths.payrollFrequencyCd}
              value={getQuoteFieldValue(propertyPaths.payrollFrequencyCd)}
              onChange={e => updateQuoteFieldValue(propertyPaths.payrollFrequencyCd, e.target.value)}
              searchKey="GPLUBenefitCoverageFundingStructure.payrollFrequencyCd"
              formFieldId={GPLU_WHOLE_LIFE_FIELD_ID.payrollFrequencyCd}
              coverageCode={GPLUCoverageCode.WHOLE_LIFE}
              required
            />
          ),
        },
      ],
    },
  ];

  return (
    <FormWrapper title="Funding Structure" collapsible expanded withSeparator>
      <Grid container alignItems="center">
        <FormRowGrid rows={rows} />
      </Grid>
    </FormWrapper>
  );
};
